const contactfilterSortReducer = (
    state = {},
    action: {
      type: "SET_CONTACT_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_CONTACT_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default contactfilterSortReducer;